//Add reference code (from References Table) here
export const SUPPORT_SITE_LINK = "SUPPORT_SITE_LINK";
export const STUDENTS_COUNT = "STUDENTS_COUNT";

//Not found in references table, but used to support an established one
export const DEFAULT_LINK = '';